class KlaviyoForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector("form");
    if (!this.form) return;

    this.listId = this.form.dataset.listId;
    this.companyId = this.form.dataset.companyId;

    this.form.email.addEventListener("keypress", this.removeError.bind(this));
    this.form.addEventListener("submit", this.handleSubmit.bind(this));
  }

  async handleSubmit(event) {
    event.preventDefault();

    const emailInput = this.form.email;
    const emailInputWrapper = emailInput.closest(".cta-input__input-wrapper");
    const emailError = this.form.querySelector(".cta-input__label-error");
    const email = emailInput.value;

    if (!this.validateEmail(email)) {
      emailInputWrapper.classList.add("error");
      emailError.textContent =
        emailInput.dataset.errorMessage || "Please enter a valid email address";
      emailInput.value = "";
      document.activeElement.blur();
      return;
    }

    this.removeError();

    try {
      const response = await fetch(
        `https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(this.companyId)}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/vnd.api+json",
            revision: "2026-01-15",
          },
          body: JSON.stringify({
            data: {
              type: "subscription",
              attributes: {
                custom_source: "Footer signup form",
                profile: {
                  data: {
                    type: "profile",
                    attributes: {
                      email,
                      subscriptions: {
                        email: {
                          marketing: {
                            consent: "SUBSCRIBED",
                            consented_at: new Date().toISOString(),
                          },
                        },
                      },
                    },
                  },
                },
              },
              relationships: {
                list: {
                  data: {
                    type: "list",
                    id: this.listId,
                  },
                },
              },
            },
          }),
        },
      );

      if (response.ok) {
        this.classList.add("success");
      } else {
        emailError.textContent =
          "Something went wrong. Please try again later.";
        emailInputWrapper.classList.add("error");
      }
    } catch {
      emailError.textContent = "Something went wrong. Please try again later.";
      emailInputWrapper.classList.add("error");
    }
  }

  removeError() {
    this.form.email
      .closest(".cta-input__input-wrapper")
      .classList.remove("error");
  }

  validateEmail(email) {
    return new RegExp("[a-z0-9]+@[a-z]+.[a-z]{2,3}").test(email);
  }
}

if (!customElements.get("klaviyo-form")) {
  customElements.define("klaviyo-form", KlaviyoForm);
}
